import { Component, EventEmitter, Input, Output } from '@angular/core';

export type LegalLang = 'en' | 'fr';

/**
 * Minimal EN/FR switch for the public pages (landing, privacy, terms).
 *
 * Deliberately independent of LangService and ngx-translate: those persist a global
 * preference that would follow the visitor into the application, and the legal copy
 * lives as prose in the templates rather than as translation keys.
 */
@Component({
    selector: 'app-legal-lang-toggle',
    templateUrl: './legal-lang-toggle.component.html',
    styleUrls: ['./legal-lang-toggle.component.scss'],
    standalone: false
})
export class LegalLangToggleComponent {

  @Input() lang: LegalLang = 'en';
  @Output() langChange = new EventEmitter<LegalLang>();

  select(lang: LegalLang) {
    if (lang !== this.lang) {
      this.langChange.emit(lang);
    }
  }

}
